export default {
  home: {
    minute: "minuto",
    price_info:
      "Los primeros {mianfei} minutos son gratuitos. El cargo máximo por 24 horas es de {currencyName}{fengding}. El banco de energía se puede devolver en cualquier estación {appName}.",
    price_info_0: "Incluye cable USB C y Lightning.",
    price_info_1:
      "Si el banco de energía no se devuelve dentro de {pOvertimeDay} días, se considerará una compra por el monto del depósito.",
    price_info_2:
      "Recomendamos devolver el banco de energía en el mismo lugar donde se alquiló. Descarga la app o escanea el código QR en la parte posterior del banco de energía para ver todas las ubicaciones de {appName}.",
    feature_1: "Incluye todos los tipos de cables: iPhone, Tipo-C",
    feature_2: "Se puede devolver en cualquier estación",
    feature_3: "Carga inalámbrica disponible",
    tips_1:
      "Tu depósito de {currencyName}{yajin} se devolverá al final del alquiler",
    tips_2:
      "El depósito de recarga {currencyName}{yajin} se puede usar para el alquiler, y cuando se agote se puede reembolsar",
    tips_3:
      "El saldo actual es de {currencyName}{myyue}, que se puede usar directamente para el alquiler",
    submit: "Comenzar alquiler",
    borrow: "Alquilar",
    msg_fail_title: "Error",
    msg_fail_content: "El alquiler falló, por favor inténtalo de nuevo",
    msg_rentcount:
      "Actualmente tienes {zujieNum} pedidos que no están cerrados",
    goborrow: "¡Ve a cargar!!!",
    nearby: "Ver estaciones cercanas",
    preauth: "Pre-autorización",
    nearbyvenues: "Venues cercanos",
    borrow_tips:
      "Seguridad de pago con tarjeta de crédito / Declaración de privacidad / Términos de uso",
    company_address: "Muamera Onerbegovica 3, 71000 Sarajevo",
    company_phone: "0038762701640",
    company_email: "info@chargi.ba",
    company_id: "ID Broj: 4203351730008",
    company_vat: "PDV broj: 203351730008",
    company_name: "ITGen d.o.o"
  },
  login: {
    welcome: "Bienvenido a {appname}",
    code_title: "Verificación",
    phone_number: "Número de teléfono",
    verification_email: "Por favor, introduce tu correo electrónico",
    verification_code: "Por favor ingresa el código de verificación",
    captcha_code: "Código",
    send_code: "Enviar Código",
    login: "Iniciar Sesión",
    agree: "Al hacer clic en Iniciar Sesión, aceptas ",
    readme: "Acuerdo de Usuario",
    msg_fail_login: "Inicio de Sesión Fallido",
    msg_success_login: "Inicio de Sesión Exitoso",
    msg_fail_user:
      "Error al obtener la información del usuario. ¿Quieres intentarlo de nuevo?",
    sign_in_with: "Iniciar sesión con",
    no_sms: "No recibí el mensaje de texto",
    retry: "Reintentar",
    email: "Correo Electrónico"
  },
  confirm: {
    deletecard: "Eliminar Tarjeta",
    addcard: "Añadir los Detalles de la Tarjeta",
    title: "Confirmación de Pago",
    paynow: "Pago Inmediato",
    label_credit_card: "Tarjeta de Crédito",
    label_apple_pay: "Apple Pay",
    label_google_pay: "Google Pay",
    label_paypal: "Paypal",
    label_klarna: "Klarna",
    label_mobile_payment: "Pago móvil",
    label_cashea: "Cashea",
    SMSConfirm:
      "Por favor paga según el mensaje de texto recibido en tu teléfono y haz clic en el botón de confirmar para continuar.",
    pay_label: "Monto",
    auth_label: "Pre-autorización",
    price_tips:
      "Tu saldo se puede retirar si lo solicitas. Puede tardar de 1 a 5 días hábiles en aparecer en tu cuenta de pago.",
    auth_tips:
      "Se requiere un monto de pre-autorización de {0}{1}. El monto real del alquiler se deducirá cuando se devuelva el banco de energía.",
    pay_type: "Por favor selecciona tu método de pago preferido",
    submit: "Confirmar Pago",
    msg_loading: "Cargando...",
    msg_fail_title: "Advertencia",
    msg_fail_payment: "No se pudo iniciar el pago del depósito",
    msg_fail_order: "No se pudo crear un pedido de alquiler",
    msg_fail_support: "El sistema no es compatible",
    msg_fail_confirm: "Confirmar",
    msg_fail_retry: "Reintentar",
    msg_fail_cancel: "Cancelar",
    payment_agreement: "Acepto y confirmo los términos de compra",
    payment_agreement_tips:
      "Por favor marca para aceptar los términos de compra",
    id_card: "Cédula de Identidad (solo dígitos)",
    id_card_tips: "Por favor, entre Cédula de Identidad"
  },
  mine: {
    title: "Perfil de Usuario",
    wallet: "Mi Cartera",
    balance: "Mi Saldo",
    deposit: "Depósito",
    wallet_in: "Recargar",
    wallet_out: "Retirar",
    wallet_log: "Registro de Cartera",
    rental_history: "Historial de Alquiler",
    payment_title: "Métodos de Pago",
    download_app: "Descargar la app",
    settings: "Configuración",
    help: "Ayuda",
    logout: "Cerrar Sesión",
    login_tips: "Por favor inicia sesión",
    msg_fail_title: "Error",
    msg_fail_update: "La modificación falló. Por favor inténtalo de nuevo",
    msg_loading: "Cargando...",
    msg_fail_user:
      "Error al obtener la información del usuario. ¿Quieres intentarlo de nuevo?",
    edit_profile: "Editar Perfil",
    join_us: "Únete a nosotros",
    join_us_details: "Obtén una estación Blitz en tu local",
    withdrawable_amount: "Cantidad retirable",
    non_withdrawable_amount: "Cantidad no retirable"
  },
  msg: {
    appoffline: "La aplicación aún no se ha iniciado, por favor espera",
    deletecard: "¿Estás seguro de que quieres eliminar esta tarjeta?",
    no_phone: "Se requiere un número de teléfono",
    loading: "Cargando...",
    title: "Consejo",
    success: "Operación Exitosa",
    error: "Error Desconocido. Por favor inténtalo de nuevo más tarde",
    roleerror: "Permisos Insuficientes. Por favor consulta al administrador.",
    neterror:
      "La conexión de red falló. Por favor inténtalo de nuevo más tarde",
    confirm: "Confirmar",
    retry: "Reintentar",
    cancel: "Cancelar",
    title_fail: "Advertencia",
    vieworder: "Ver Pedido",
    success_payment: "Pago Completado",
    success_buy: "Compra Completada",
    fail_payment: "Fallo en el Pago",
    keyword: "Palabra Clave",
    ispayorder: "Por favor confirma si se ha realizado el pago",
    unpay: "No Pagado",
    yespay: "Pagado",
    notopen: "Aún no Abierto",
    please_enter: "Por favor introduce."
  },
  result: {
    tips:
      "Para ver pedidos y otras ubicaciones de estaciones, por favor descarga la aplicación.",
    download: "Descargar la app",
    title: "Alquiler Confirmado",
    gotit: "Entendido",
    price_plan: "Tarifa Estándar",
    msg_success: "Alquilado con éxito",
    msg_tips_loading:
      "El banco de energía se está expulsando, por favor espera...",
    msg_result_loading: "Se está confirmando el resultado del pago...",
    msg_fail_confirm: "Confirmar",
    btn_usage: "Nota de Uso",
    btn_return: "Nota de Devolución",
    deposit: "Depósito",
    msg_fail_content: "La solicitud falló. Por favor inténtalo de nuevo.",
    price_label: "por hora",
    price_info:
      "Los primeros {mianfei} minutos son gratuitos. Cargo máximo diario de {ccurrency}{fengding}. El depósito se deducirá automáticamente cuando el alquiler alcance {ccurrency}{yajin}",
    tips_1:
      "Por favor recoge el banco de energía No.{number} como se muestra en la imagen",
    tips_2:
      "Por favor organiza los cables e inserta el banco de energía en la ranura con el lado marcado con [flechas hacia abajo]",
    msg_note_usage:
      "El banco de energía está equipado con 3 tipos de cables, por favor elige el que necesites para tu dispositivo.",
    msg_note_return:
      "Por favor organiza los cables e inserta el banco de energía en la ranura con el lado marcado con [flechas hacia abajo]",
    return_info:
      "Al devolverlo, asegúrate de que los cables estén ordenados e inserta el lado con chips metálicos en un enchufe disponible hasta que llegue al fondo y se estabilice.",
    download_tips:
      "Para alquilar nuestro banco de energía, puedes elegir una de las siguientes opciones"
  },
  result_msg: {
    loading: "Cargando...",
    refresh: "Actualizar"
  },
  order: {
    title: "Historial de Alquiler",
    in_use: "En Uso",
    ended: "Terminado",
    msg_error: "Solicitud fallida",
    order_number: "No.",
    order_details: "Detalles del Pedido",
    order_zj_shop: "Venue alquilado",
    order_zj_time: "Hora de alquiler",
    order_gh_shop: "Venue devuelto",
    order_gh_time: "Hora de devolución",
    order_use_time: "Tiempo de Uso",
    order_amount: "Monto total",
    not_on_rent: "No en alquiler",
    renting: "En alquiler",
    undone: "Sin finalizar",
    returned: "Devuelto",
    questions: "Preguntas",
    timeout_to_return: "Tiempo límite para devolver",
    suspended_for_billing: "Suspendido por facturación"
  },
  order_item: {
    order_number: "No.",
    venue_rented: "Ubicación de Recogida",
    time_rented: "Hora de Recogida",
    venue_returned: "Ubicación de Devolución",
    time_returned: "Hora de Devolución",
    charge_standard: "Tarifa estándar",
    charge_standard_info:
      "{pJifei} {pCurrency} por hora (primeros {pMian} minutos gratis)",
    rent_occurred: "Alquiler",
    returned: "Devuelto",
    unreturned: "No Devuelto",
    type_0: "No Completado",
    type_1: "Alquilando",
    type_2: "Cancelado",
    type_3: "Devuelto",
    type_4: "Error ocurrido",
    type_5: "Tiempo extra",
    min: "Min",
    payment: "Pago",
    unpay: "No Pagado"
  },
  setting: {
    title: "Configuración",
    lang: "Idioma"
  },
  help: {
    title: "Preguntas Frecuentes",
    rentals: "Alquileres",
    venues: "Venues",
    payments: "Pagos"
  },
  wallet_in: {
    title: "Recarga de Saldo",
    price_label: "Monto de Recarga",
    price_placeholder: "Por favor ingresa el monto de recarga",
    balance: "Saldo Actual",
    price_auto: "Seleccionar Monto de Pago",
    price_tips:
      "Tu saldo se puede retirar bajo solicitud. Puede tardar de 1 a 5 días hábiles en aparecer en tu cuenta de pago.",
    submit: "Enviar",
    loading: "Cargando...",
    paying: "Redireccionando a la página de pago...",
    msg_title: "Consejos",
    msg_fail_order: "Error al crear la orden de recarga",
    msg_fail_payment: "Error al iniciar el pago de recarga",
    msg_fail_retry: "Reintentar"
  },
  wallet_out: {
    title: "Retiro",
    price_label: "Monto de Retiro",
    price_placeholder: "Por favor ingresa el monto de retiro",
    balance: "Saldo Actual",
    balance_all: "Retirar Todo",
    deposit: "Depósito",
    deposit_tips:
      "Hay un pedido de alquiler pendiente. El depósito de Ksh{pyajin} no es reembolsable",
    submit: "Enviar",
    apply: "Aplicar",
    confirm: "Confirmar",
    loading: "Cargando...",
    msg_fail_price: "El monto de retiro es incorrecto",
    msg_fail_balance: "El monto de retiro no puede exceder el saldo actual",
    msg_fail_submit: "Por favor completa toda la información requerida",
    msg_title: "Error",
    msg_success_content: "Reembolso Exitoso",
    confirmtitle: "Consejos",
    confirmcontent:
      "La cartera actual no admite retiros en efectivo. Por favor registra tu información de contacto para el procesamiento de reembolso manual",
    payee_name: "Nombre del Beneficiario",
    payee_bankcard: "Número de Tarjeta Bancaria",
    payee_phone: "Teléfono",
    cancelText: "Cancelar",
    confirmText: "Volver a Aplicar"
  },
  map: {
    scan_qa_code: "ESCANEAR",
    在线: "En Línea",
    离线: "Fuera de Línea",
    title: "Estación Cercana",
    result_msg: "No se encontró ninguna estación cercana",
    msg_title: "error",
    no_support: "¡Lo sentimos! Tu navegador no soporta servicios de ubicación",
    my_position: "Mi Ubicación",
    distance: "Distancia:",
    shop_time: "Horas",
    free: "Disponible para Alquilar",
    return: "Ranuras vacías disponibles",
    shop_title: "Detalles del Local",
    address: "Dirección",
    go_here: "Ir aquí",
    nav_help: "Ayuda",
    nav_search: "Buscar",
    locate: "Localizar"
  },
  scanQr: {
    NotAllowedError: "Necesitas otorgar acceso a la cámara",
    NotFoundError: "No hay cámara en este dispositivo",
    NotSupportedError: "Contexto de seguridad requerido (HTTPS, localhost)",
    NotReadableError: "La cámara está en uso",
    OverconstrainedError: "La instalación de la cámara es inapropiada",
    StreamApiNotSupportedError: "Este navegador no soporta la API de streaming"
  },
  payment: {
    payment_title: "Métodos de Pago",
    pay_type: "Por favor añade los detalles de tu tarjeta",
    add_payment_card: "Añadir Tarjeta de Pago",
    add_payment: "añadir pago"
  },
  shop: {
    title: "Estación Cercana",
    search_station: "Buscar una estación",
    search_station_tips: "Por favor introduce el nombre de la estación",
    shop_power_banks: "Bancos de Energía",
    shop_empty_slots: "Ranuras Vacías",
    shop_address: "Dirección",
    shop_business_hours: "Horario de Atención",
    shop_directions_station: "Cómo llegar a la estación",
    shop_scan_qrcode: "Escanear código QR"
  },
  time: {
    days: "Días",
    hours: "Horas",
    minutes: "Minutos"
  },
  bncPay: {
    p2p_title: "Info pago",
    copy_all: "Copiar todo",
    copied: "Copiado",
    please_select: "Por favor selecciona",
    bank_code: "Banco",
    phone_number: "Número de Teléfono",
    reference: "Referencia",
    request_date: "Fecha de Solicitud",
    card_type: "Tipo de Tarjeta",
    card_holder_id: "ID del Titular de la Tarjeta",
    card_holder_name: "Nombre del Titular de la Tarjeta",
    card_number: "Número de Tarjeta",
    expiry_date: "MM-AAAA",
    cvv: "CVV",
    card_pin: "PIN de Tarjeta",
    cancel: "Cancelar",
    confirm: "Confirmar",
    please_select_bank: "Por favor selecciona Banco",
    please_enter_phone: "Por favor ingresa el Número de Teléfono",
    please_enter_reference: "Por favor ingresa la Referencia",
    please_enter_date: "Por favor ingresa la Fecha de Solicitud",
    please_select_card_type: "Por favor selecciona el Tipo de Tarjeta",
    please_enter_holder_id: "Por favor ingresa el ID del Titular",
    please_enter_holder_name: "Por favor ingresa el Nombre del Titular",
    please_enter_card_number: "Por favor ingresa el Número de Tarjeta",
    please_enter_expiry: "Por favor ingresa la Fecha de Vencimiento",
    please_enter_cvv: "Por favor ingresa el CVV",
    please_enter_pin: "Por favor ingresa el PIN de Tarjeta",
    visa: "VISA",
    master_card: "Master Card",
    master_debit: "Master Débito"
  }
};
